import {
  PlateElement,
  PlateElementProps,
} from 'lib-knowledge-document-structure/plate/common';
import {
  MyAnchorLinkElement,
  MyValue,
} from 'lib-knowledge-document-structure/plateTypes';
import { forwardRef } from 'react';

import s from './elements.module.scss';

const AnchorLinkElement = forwardRef<
  React.ElementRef<typeof PlateElement>,
  PlateElementProps<MyValue, MyAnchorLinkElement>
>(({ className, children, ...props }, ref) => {
  return (
    <PlateElement asChild ref={ref} className={className} {...props}>
      <a className={s.link}>{children}</a>
    </PlateElement>
  );
});

AnchorLinkElement.displayName = 'AnchorLinkElement';
export { AnchorLinkElement };
